import { FC } from 'react';
import { ChildDataProps, graphql } from '@apollo/client/react/hoc';
import { ApolloError } from '@apollo/client';

import IS_USER_AUTHENTICATED_QUERY from './query';
import {
  IsUserAuthenticatedQuery,
  IsUserAuthenticatedQuery_user,
} from './__generated__/IsUserAuthenticatedQuery';

type Props = ChildDataProps<{}, IsUserAuthenticatedQuery>;

interface ChildProps extends Omit<IsUserAuthenticatedQuery_user, '__typename'> {
  loading: boolean;
  error?: ApolloError;
}

interface UserWrapperProps extends Props {
  children?: (props: ChildProps) => JSX.Element | null;
}

const withUserAuthenticationData = graphql<
  {},
  IsUserAuthenticatedQuery,
  {},
  Props
>(IS_USER_AUTHENTICATED_QUERY, {
  options: {
    fetchPolicy: 'network-only',
  },
});

export const UserWrapper: FC<UserWrapperProps> = ({
  children,
  data: { loading, error, user },
}) =>
  children
    ? children({
        error,
        loading,
        id: user?.id ?? null,
        isAuthenticated: user ? user.isAuthenticated : false,
        registrations: user?.registrations || [],
      })
    : null;

export default withUserAuthenticationData(UserWrapper);
